import { isNull, parseAddress } from '../common';
import { instance } from './instance-api';

export interface Quiz {
    _id: string;
    points: number;
    name: string;
    question_type: string;
    options: string[];
    duration: number;
    user: string;
    date_till: string | Date | null;
    start: string | Date | null;
    end: string | Date | null;
}

export interface PostQuizOptions {
    address: string;
    signature: string;
    answer: string;
    quiz_id: string;
}

export interface PostQuizAnswerResponse {
    success: boolean;
    reason: string;
}

export const getQuiz = async (address: string, signature: string, startQuiz: boolean) => {
    const response = await instance
        .post<Quiz>('/quiz', {
            address: parseAddress(address),
            signature,
            startQuiz,
        })
        .catch(() => null);
    //Gotta convert to ISO format
    return isNull(response) || isNull(response.data)
        ? null
        : {
              ...response.data,
              date_till: response.data.date_till ? new Date(response.data.date_till + 'Z') : null,
              start: response.data.start ? new Date(response.data.start + 'Z') : null,
              end: response.data.end ? new Date(response.data.end + 'Z') : null,
          };
};

export const postQuizAnswer = async (data: PostQuizOptions): Promise<PostQuizAnswerResponse> => {
    const response = await instance
        .post('/quiz_save', {
            ...data,
            address: parseAddress(data.address),
        })
        .catch((error) => error.response.data.detail);
    return { success: !isNull(response) && response.data === 'ok', reason: response };
};
